module.exports = __webpack_public_path__ + "static/media/volume_white.14e76798.svg";